var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMad = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0934 10.115H13.6759L12.0018 4.96265L10.3277 10.115H4.91016L9.29302 13.2993L7.61888 18.4517L12.0018 15.2674L16.3847 18.4518L14.7105 13.2993L19.0934 10.115ZM10.5197 12.9007L11.0858 11.1584H12.9177L13.4839 12.9007V12.9007L12.0018 13.9775L10.5197 12.9007L10.5197 12.9007ZM12.5787 10.115H11.4249L12.0018 8.33933L12.5787 10.115ZM14.3715 12.2558L14.0149 11.1584H15.8819L14.3715 12.2558ZM9.98864 11.1584L9.63206 12.2558L8.12161 11.1584H9.98864ZM9.6037 15.7199L10.1806 13.9443L11.1142 14.6225L9.6037 15.7199ZM12.8894 14.6225L13.8229 13.9443L14.3999 15.7199L12.8894 14.6225Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMad);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MAD.7c6feeeacd6bd82a275b5dff7e273b25.svg";